export const tagFragment = `
  id
  text
  order
  operatorOnly
  games {
    id
  }
`;
